import {
  GET_FABRIC_TRADING_RESOURCE,
  GET_FABRIC_TRADING_RESOURCE_SUCCESS,
  GET_FABRIC_TRADING_RESOURCE_ERROR,
  GET_FABRIC_TRADING_LIST_RESOURCE,
  GET_FABRIC_TRADING_LIST_RESOURCE_SUCCESS,
  GET_FABRIC_TRADING_LIST_RESOURCE_ERROR,
} from "./actionTypes"

export const getFabricTradingResource = data => ({
  type: GET_FABRIC_TRADING_RESOURCE,
  payload: data,
})

export const getFabricTradingResourceSuccess = data => ({
  type: GET_FABRIC_TRADING_RESOURCE_SUCCESS,
  payload: data,
})

export const getFabricTradingResourceError = data => ({
  type: GET_FABRIC_TRADING_RESOURCE_ERROR,
  payload: data,
})

export const getFabricTradingListResource = data => ({
  type: GET_FABRIC_TRADING_LIST_RESOURCE,
  payload: data,
})

export const getFabricTradingListResourceSuccess = data => ({
  type: GET_FABRIC_TRADING_LIST_RESOURCE_SUCCESS,
  payload: data,
})

export const getFabricTradingListResourceError = data => ({
  type: GET_FABRIC_TRADING_LIST_RESOURCE_ERROR,
  payload: data,
})
